import { TouchableOpacity } from "react-native";
import { Spacings, View } from "react-native-ui-lib";
import { CIRCLE_DIAMETER } from "../../constants";

export type ItemProps = {
  selected?: boolean;
  hexCode: string;
  onPress: () => void;
};

export function Item({ selected = false, hexCode, onPress }: ItemProps) {
  return (
    <View
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: Spacings.s1,
        paddingBottom: selected ? Spacings.s1 : undefined,
        borderBottomWidth: selected ? 2 : 0,
        borderBottomColor: hexCode,
      }}
    >
      <TouchableOpacity
        key={hexCode}
        style={{
          backgroundColor: hexCode,
          width: CIRCLE_DIAMETER,
          height: CIRCLE_DIAMETER,
          borderRadius: CIRCLE_DIAMETER / 2,
          borderColor: "#00000022",
          borderWidth: 1,
        }}
        onPress={onPress}
      />
    </View>
  );
}
